import React, { useEffect } from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { useThemesContext } from "../context/ThemeProvider";
import { Route, Switch } from "react-router-dom";
import loadable from "@loadable/component";

export const VisualEditor = loadable(() => import(/* webpackChunkName: "VisualEditor" */ "../screens/visual"), { ssr: false });
export const CodeEditor = loadable(() => import(/* webpackChunkName: "CodeEditor" */ "../screens/code"), { ssr: false });



const EditorWrapper = () => {

    const { themeId } = useParams();
    const shopId = useSelector(({ auth }) => auth?.shop?.id);
    const {
        getThemeById,
        getMenus,
        getPages,
        getProductList,
        getFeedbackList,
        getTicketList,
        getInvoiceList,
        resetMenuState,
        setSelectedTemplate
    } = useThemesContext();

    useEffect(() => {
        if(shopId) {
            resetMenuState();
            setSelectedTemplate(null);
            getThemeById(themeId);
            getMenus();
            getPages();
            getProductList();
            getFeedbackList();
            getTicketList();
            getInvoiceList();

        }
    }, [shopId, themeId]);

    return (
        <div className="editor-screen app-body">
            <Switch>
                <Route path="/editor/:themeId/visual" component={VisualEditor} />
                <Route path="/editor/:themeId/code" component={CodeEditor} />
            </Switch>
        </div>
    )
}

export default EditorWrapper